import { render, staticRenderFns } from "./AddVerificationIdentite.vue?vue&type=template&id=4ce6f76b&scoped=true&"
import script from "./AddVerificationIdentite.vue?vue&type=script&lang=js&"
export * from "./AddVerificationIdentite.vue?vue&type=script&lang=js&"
import style0 from "./AddVerificationIdentite.vue?vue&type=style&index=0&id=4ce6f76b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce6f76b",
  null
  
)

export default component.exports